import { create } from 'zustand';

import { IContractPaginated } from '../services/getPaginateContracts';

interface ISelectedContractForReissueStore {
  selectedContractForReissue: IContractPaginated;
  setContractForReissue: (register: IContractPaginated) => void;
  removeContractForReissue: () => void;
}

export const useSelectedContractForReissueStore =
  create<ISelectedContractForReissueStore>(set => {
    return {
      selectedContractForReissue: {} as IContractPaginated,
      setContractForReissue(register: IContractPaginated) {
        set({ selectedContractForReissue: register });
      },
      removeContractForReissue() {
        set({ selectedContractForReissue: {} as IContractPaginated });
      },
    };
  });
